
import { Vue, Component } from 'vue-property-decorator';
import PrintCard from '@/features/shipment/components/print/PrintCard.vue';

@Component({
  components: {
    PrintCard,
  },
})
export default class Print extends Vue {
  mounted(): void {
    const { query } = this.$route;
    if (query.from === '3ds') {
      this.$store.dispatch('clearInProgressDataInShortly');
      this.$store.dispatch('clearEstimateDataInShortly');

      this.$router.replace({
        name: 'shipment-print',
        query: { id: query.id },
      });
    }
  }
}
